










import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { FilterDay } from '../interfaces/filter-model'

@Component({
  components: {}
})

export default class DialogSelectDayForm extends Vue {
  @Prop({ type: Object as () => FilterDay }) readonly filterData!: any

  filter = {
    value: 0
  }

  mounted () {
    this.filter.value = this.filterData.value
  }

  @Watch('filterData', { deep: true })
  onProps (val: FilterDay) {
    if (val) {
      this.filter.value = this.filterData.value
    }
  }

  @Emit('change')
  onChange () {
    return {
      key: this.filterData.key,
      value: this.filter.value
    }
  }

  handleValue (val: number) {
    this.onChange()
  }
}
